/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ min: NonNullable<unknown>, metric: NonNullable<unknown> }} Perks_Trigger_Stat_AllInputs */



/**
* | output |
* | --- |
* | "{min} {metric} of all time" |
*
* @param {Perks_Trigger_Stat_AllInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perks_trigger_stat_all = /** @type {((inputs: Perks_Trigger_Stat_AllInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perks_Trigger_Stat_AllInputs, { locale?: "en" | "ru" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.min} ${i?.metric} за всё время`)
	return /** @type {LocalizedString} */ (`${i?.min} ${i?.metric} of all time`)
});